'use strict';

var React = require("react");
var Marked = require("marked");

function toHHMM(date) {
  var pad = function (n) {
    if (n < 10) {
      return "0" + String(n);
    } else {
      return String(n);
    }
  };
  var hh = pad(date.getUTCHours() | 0);
  var mm = pad(date.getUTCMinutes() | 0);
  return "" + (String(hh) + (":" + (String(mm) + "")));
}

function componentOrNull(condition, component) {
  if (condition) {
    return component;
  } else {
    return null;
  }
}

function s(prim) {
  return prim;
}

function ate(prim) {
  return prim;
}

function md(markdownString) {
  var res = Marked(markdownString, {
        gfm: true,
        smartLists: true,
        smartypants: true
      });
  var props = {
    className: "markdown-container",
    dangerouslySetInnerHTML: {
      __html: res
    }
  };
  return React.createElement("section", props);
}

exports.toHHMM = toHHMM;
exports.componentOrNull = componentOrNull;
exports.s = s;
exports.ate = ate;
exports.md = md;
/* react Not a pure module */



// WEBPACK FOOTER //
// ./src/layouts/util.js